import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { STATUS } from '../../utils/status';
import { workflowState } from '../interfaces/interface';
import { createWorkflow, createWorkflowLink, getWorkflowNodes } from '../slices/workflow';

const ExtraReducers = (builder: ActionReducerMapBuilder<workflowState>) => {
  builder
    .addCase(createWorkflow.pending, (state) => {
      state.createWorkflowStatus = STATUS.PENDING;
    })
    .addCase(createWorkflow.fulfilled, (state, action: PayloadAction<any>) => {
      state.workflow = action.payload; 
      state.createWorkflowStatus = STATUS.SUCESS; 
    })
    .addCase(createWorkflow.rejected, (state, action) => { 
      state.createWorkflowStatus = STATUS.FAILED;
    })
    .addCase(createWorkflowLink.pending, (state) => {
      state.createWorkflowLinkStatus = STATUS.PENDING;
    })
    .addCase(createWorkflowLink.fulfilled, (state, action: PayloadAction<any>) => {
      state.workflow = action.payload; 
      state.createWorkflowLinkStatus = STATUS.SUCESS; 
    })
    .addCase(createWorkflowLink.rejected, (state, action) => { 
      state.createWorkflowLinkStatus = STATUS.FAILED;
    })
    .addCase(getWorkflowNodes.pending, (state) => {
      state.getWorkflowNodesStatus = STATUS.PENDING;
    })
    .addCase(getWorkflowNodes.fulfilled, (state, action: PayloadAction<any>) => {
      state.collection = action.payload; 
      state.getWorkflowNodesStatus = STATUS.SUCESS; 
    })
    .addCase(getWorkflowNodes.rejected, (state, action) => { 
      state.getWorkflowNodesStatus = STATUS.FAILED;
    })
};

export default ExtraReducers;